import React, { useCallback, useEffect, useRef, useState } from 'react'
import './TeacherStudentSidebar.scss';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import images from '../../assets/images';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { logout, setRefetchNotification, setSplashvisible } from '../../redux/slices/authSlice';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, LOGOUT_MESSAGE_IN_MEETING_HOST, LOGOUT_MESSAGE_IN_MEETING_PARTICIPANT, LOGOUT_MESSAGE_NOT_IN_MEETING, PATH_ADDRESSES, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE, VIRTUAL } from '../../utils/constants';
import { GET_CHAT_INDICATION, GET_CLASSROOM_UPDATES, GET_NOTIFICATIONS } from '../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { useLazyQuery, useMutation } from '@apollo/client';
import ToasterWithMessage from '../toaster';
import { setCategoryListLoading, setChangeMenu, setCurrentSessionRecordingDetail } from '../../redux/slices/dashboardSlice';
import { UPDATE_ACTIVE_STATUS } from '../../pages/CommonChats/api/ChatsQuery';
import { MeetingCategoryType } from '../../pages/AdminPta/AdminPta';
import { GET_ALL_MEETING_CATEGORIES, UPDATE_MEETING_STATUS } from '../../pages/AdminPta/api/PtaQuery';
import { GetChatCountResponse, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables } from '../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom';
import { setChatTabIndication, setTabIndication } from '../../redux/slices/indication';
import { isPlatform } from '@ionic/react';
import { Tooltip } from '@mui/material';
import { DELETE_SESSION_PARTICIPANT, UPDATE_SESSION_RECORD } from '../../Chime/helpers/Api/ChimeApi';
import { UPDATE_WORKSHOP_ENDED, UPDATE_WORKSHOP_MEETING_ID } from '../../pages/Workshop/api/WorkshopQuery';
import { END_THE_LIVE_SESSION } from '../../pages/LiveClass/api/LiveClassQuery';
import { getIsJoinedLocalValue } from '../../utils/helper';

interface notificationType{
  Announcement:number;
  Calender:number;
  Workshop:number
};

interface menuItemType {
  id: string;
  label: string;
  link: string;
  notificationKey?: string;
}

const TeacherStudentSidebar = () => {

  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
  const [openConfirmationPopup,setOpenConfirmationPopup] = useState<boolean>(false);
  const location = useLocation();
  const {rightSideArrow, LogoutIcons, logoutGif, SettingsIcons, HelpIcon, redDotImage} = images;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const role = useAppSelector((state) => state.auth.role);
  const classRoomName = useAppSelector((state) => state.auth.selectedClassRoomName);
  const [notification,setNotification] = useState<notificationType>();
  const {error} = ToasterWithMessage();
  const [allCategory, setAllCategory] = useState<MeetingCategoryType[]>([]);
  const [oneMenuItems, setOneMenuItems] = useState<menuItemType[]>([]);
  const changeMenu = useAppSelector((state) => state.dashboard.changeMenu);
  const [showPtaSideBar, setShowPtaSideBar] = useState<boolean>(false);
  const refetchNotification = useAppSelector((state) => state?.auth?.refetchNotification);
  const selectedCategory: MeetingCategoryType = location?.state?.category; 
  // const [isIndication, setIndication] = useState<boolean>(false)
  const isIndication = useAppSelector((state) => state.indication.tabIndication)
  const isIndicationChat = useAppSelector((state) => state.indication.chatTabIndication)
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const meetComponent = useAppSelector((state) => state?.dashboard?.meetComponent);
  const { currentSessionId, currentWorkshopId, currentPtaMeetId } = useAppSelector((state) => state?.dashboard);
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const participantCode = useAppSelector((state) => state.auth.participantCode);
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  const [isOverflow, setIsOverflow] = useState(false);
  const schoolNameRef = useRef<HTMLDivElement | null>(null);
  const currentParticipantId = localStorage.getItem("jitsiLocalParticipantId");
  const isMeetRecording = localStorage.getItem("isMeetRecording");
  const [logoutMessage, setLogoutMessage] = useState<string>('');

  const onTeacherStudentLogoutClick = () => {
    const isJoined = getIsJoinedLocalValue();

    if(isJoined && isJoined === "joined"){
      if(((meetComponent === 'liveclass') && (role === TEACHER_ROLE)) || ((meetComponent === 'workshop') && (role === SCHOOL_ADMIN)) || ((meetComponent === 'pta') && (role === SCHOOL_ADMIN))) {
        setLogoutMessage(LOGOUT_MESSAGE_IN_MEETING_HOST);  
      } else {
        setLogoutMessage(LOGOUT_MESSAGE_IN_MEETING_PARTICIPANT);
      }
    } else {
      setLogoutMessage(LOGOUT_MESSAGE_NOT_IN_MEETING);
    }
    setOpenConfirmationPopup(true);
  }

  const menuItems: menuItemType[] = [
    {id: "classroom", label: 'Classroom', link: role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH},
    ...(schoolType !== VIRTUAL ? [{id: "workshop", label: 'Workshop', link: role === TEACHER_ROLE ? '/teacher-workshop' : PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH, notificationKey: 'Workshop'}] : []),
    ...(schoolType !== VIRTUAL ? [{id: "calendar", label: 'Calendar', link: role === TEACHER_ROLE ? '/teacher-calendar' :'/student-calendar', notificationKey: 'Calender'}] : []),
    {id: "announcement", label: 'Announcement', link: role === TEACHER_ROLE ? '/teacher-announcement':'/student-announcement', notificationKey: 'Announcement'},
    // ...(isPlatform('android')) ? [{id: "inAppDownloads", label: 'Downloads', link: role === TEACHER_ROLE ? '/teacher-downloads':'/student-downloads', notificationKey: 'inAppDownloads'}] : [{id: "inAppDownloadsElectron", label: 'Downloads', link: role === TEACHER_ROLE ? '/teacher-InAppdownloads' : '/student-InAppdownloads', notificationKey: 'inAppDownloads'}],
    ...(window?.electron?.isElectron()) ? [{id: "inAppDownloadsElectron", label: 'Downloads', link: role === TEACHER_ROLE ? '/teacher-InAppdownloads' : '/student-InAppdownloads', notificationKey: 'inAppDownloads'}]:[],
    ...(((role === TEACHER_ROLE) && (schoolType !== VIRTUAL)) ? [{id: "ptameetings", label: 'PTA Meetings', link: PATH_ADDRESSES?.TEACHER_PTA_PATH, notificationKey: 'Ptameetings'}] : [])
  ]

  const setTwoMenuItems = [
    ...((role !== PTA_ROLE) ? [{id: "settings", label: 'Settings', link: role === TEACHER_ROLE ? '/teacher-settings' : '/student-settings', icon: SettingsIcons},
    ...(schoolType !== VIRTUAL ? [{id: "help", label: 'Help', link: role === TEACHER_ROLE ? '/teacher-help' : '/student-help', icon: HelpIcon}] : []),
    ] : []),
    {id: "logout", label: 'Logout', link: '/teacher-logout', icon: LogoutIcons, onClick: onTeacherStudentLogoutClick},
  ]

  const [getNotifications] = useLazyQuery(GET_NOTIFICATIONS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setNotification(data?.notifyUser);
    }
  });

  const [updateChatActiveStatus] = useMutation(UPDATE_ACTIVE_STATUS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [getAllMeetingCategory, { loading: categoryLoading }] = useLazyQuery(GET_ALL_MEETING_CATEGORIES, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      const ptaMenuItems: menuItemType[] = []
      setAllCategory(data?.allMeetingCategories?.nodes);
      data?.allMeetingCategories?.nodes?.map((val: MeetingCategoryType, index: number) => {
        if (index === 0 && (role === PTA_ROLE || role === TEACHER_ROLE)) {
          localStorage.setItem("generalCode", val?.mcCode);
        }
        ptaMenuItems.push({
          id: val?.mcCode,
          label: val?.mcOriginalType,
          link: role === PTA_ROLE ? PATH_ADDRESSES?.PTA_MEETINGS_PATH : PATH_ADDRESSES?.TEACHER_PTA_PATH,
        });
      })
      if ((role === TEACHER_ROLE || role === PTA_ROLE) && selectedCategory === undefined) {
        localStorage.setItem('isVerify','false');
        navigate(ptaMenuItems?.[0]?.link, {
          state: {
            category: data?.allMeetingCategories?.nodes?.[0]
          }
        });
      }
      setOneMenuItems(ptaMenuItems);
    },
    onError: (err) => {
      error(err?.message);
    }
  })

  useEffect(()=>{
    if (role !== PTA_ROLE) {
      getNotifications();
    }
  },[]);

  useEffect(()=>{
    if (role !== PTA_ROLE && refetchNotification) {
      getNotifications();
      dispatch(setRefetchNotification({ refetchNotification: false }));
    }
  },[refetchNotification]);

  useEffect(() => {
    setShowPtaSideBar(false);
    if (location.pathname === PATH_ADDRESSES?.TEACHER_PTA_PATH || location.pathname === PATH_ADDRESSES?.PTA_MEETINGS_PATH || showPtaSideBar) {
      if (allCategory.length === 0 || allCategory === undefined) {
        getAllMeetingCategory();
      }
    }
    else {
      setOneMenuItems(menuItems);
    }
  },[location.pathname, role, schoolType])

  useEffect(() => {
    if (changeMenu) {
      handleClick({id: "classroom", label: 'Classroom', link: '/teacher-classroom'});
      dispatch(setChangeMenu({changeMenu: false}));
    }
  },[changeMenu])

  useEffect(() => {
    dispatch(setCategoryListLoading({ categoryListLoading: categoryLoading }))
  },[categoryLoading])

    const [deleteSessionParticipant] = useMutation(DELETE_SESSION_PARTICIPANT, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {
        console.log("Participant deleted successfully:", data);
      },
      onError: (err) => {
        console.log(err)
        // error("Error deleting participant:");
      },
    });

    // API's for updating the live class record start timer and recording status
    const [updateSessionRecord] = useMutation(UPDATE_SESSION_RECORD, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });  

    // API to update Workshop staring status, recording status and recording timer
    const [updateWorkshopSession] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });  
    
    // API to update PTA meeting status, recording timer and recording status
    const [updatePtaMeeting] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    }); 

    // API's for updating the live class end status
    const [updateSessionEnd] = useMutation(END_THE_LIVE_SESSION, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });   
    
    // API to update Workshop end status
    const [updateWorkshopEnd] = useMutation(UPDATE_WORKSHOP_ENDED, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });     
  
    const handleDeleteParticipant = async () => {
      console.log("[logout] all values", meetComponent, currentSessionId, selectedSubjectId, selectedClassRoomId, currentParticipantId);
        if (
          meetComponent === "liveclass" &&
          currentSessionId &&
          selectedSubjectId &&
          selectedClassRoomId
        ) {
          deleteSessionParticipant({
            variables: {
              cId: selectedClassRoomId,
              sId: currentSessionId,
              sjId: selectedSubjectId,
              participantId: currentParticipantId,
            },
          });
        }
    }

    const handleUpdateRecordTime = async (recordingStatus: boolean, recordStartTime: string) => {
        if (meetComponent === "liveclass" && selectedClassRoomId && currentSessionId && selectedSubjectId) {
            await updateSessionRecord({
                variables: {
                    cId: selectedClassRoomId,
                    sId: currentSessionId,
                    sjId: selectedSubjectId,
                    isRecordStart: recordingStatus,
                    recordStarttime: recordStartTime,
                },
            });
        } else if (meetComponent === "workshop" && currentWorkshopId) {
            await updateWorkshopSession({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime: recordStartTime,
                    },
                    wsId: currentWorkshopId,
                }
            });
        } else if (meetComponent === "pta" && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime: recordStartTime,
                    },
                    mId: currentPtaMeetId,
                }
            });
        }
        localStorage.setItem("isMeetRecording", recordingStatus ? "true" : "false");
        dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: recordStartTime, recordingStarted: recordingStatus }));
    };  
    
    const updateEndMeeting = async () => {
        console.log("[Log] updateEndMeeting called");
        if (meetComponent === "liveclass" && (role === TEACHER_ROLE) && selectedSubjectId && currentSessionId && selectedClassRoomId) {
            await updateSessionEnd({
                variables: {
                cId: selectedClassRoomId,
                sId: currentSessionId,
                sjId: selectedSubjectId,
                },
            });
        } 
        else if (meetComponent === "workshop" && (role === SCHOOL_ADMIN) && currentWorkshopId) {
            await updateWorkshopEnd({
                variables: {
                wsId: currentWorkshopId,
                },
            });
        } 
        else if (meetComponent === "pta" && (role === SCHOOL_ADMIN) && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                updateInput: {
                    mStatus: "ENDED",
                },
                mId: currentPtaMeetId,
                },
            });
        } 
    }

  // click yes button in confirmation popup
  const onClickYesButtonClick = async () => {
    setOpenConfirmationPopup(false);
    // if ((role === TEACHER_ROLE || role === STUDENT_ROLE) && schoolType !== VIRTUAL) {
    if ((role === TEACHER_ROLE || role === STUDENT_ROLE)) {
      await updateChatActiveStatus({
        variables: {
          chatActive: false
        }
      })
        .then(() => {
          // This block runs after the updateChatActiveStatus mutation is successfully completed
          // dispatch(logout());
          // dispatch(setSplashvisible());
          // setOpenConfirmationPopup(false);
        })
        .catch((error) => {
          console.error("Failed to update chat active status:", error);
          // You can handle the error appropriately here, e.g., show a notification to the user
        });
    }  
    if (currentParticipantId && currentParticipantId !== "") {
      await handleDeleteParticipant();
    } 

    if(isMeetRecording === "true") {
      await handleUpdateRecordTime(false, new Date().toISOString());
    }
    
    const isJoined = getIsJoinedLocalValue();
    if(isJoined === 'joined') {
      await updateEndMeeting();
    }
    
      // Directly proceed with logout and other actions if not a TEACHER or STUDENT
      dispatch(logout());
      dispatch(setSplashvisible());
  };


  // click no button in confirmation popup
  const onClickNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  const [getClassRoomUpdates] = useLazyQuery<
    GetClassroomUpdatesResponse,
    GetClassroomUpdatesVariables
  >(GET_CLASSROOM_UPDATES, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      const { quiz, assignments, mylibrary, ebooks } = data.getClassroomUpdates;
      const quizCount = quiz.totalCount;
      const hasQuiz = quizCount > 0;
      const assignmentCount = assignments.totalCount;
      const hasAssignment = assignmentCount > 0;
      const myLibrayCount = mylibrary.totalCount;
      const ebooksCount = ebooks.totalCount;
      const hasMylibrary = myLibrayCount > 0;
      const hasEbooks = ebooksCount > 0;

      // Set tab indication based on either quiz or assignment presence
      dispatch(
        setTabIndication(hasQuiz || hasAssignment || hasMylibrary || hasEbooks)
      );
    },
    onError: (err) => {
      console.log(err.message);
    },
  });

  //indication for chat
  const [getIndicationChat] = useLazyQuery<
    GetChatCountResponse,
    GetClassroomUpdatesVariables
  >(GET_CHAT_INDICATION, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      const chatCount = data.getAllChatCount;
      const hasChat = chatCount > 0;
      dispatch(setChatTabIndication(hasChat));
    },
    onError: (err) => {
      console.log(err.message);
    },
  });

  const handleClick = async (menu: menuItemType) => {
    if (menu?.link === PATH_ADDRESSES?.TEACHER_PTA_PATH || menu?.link === PATH_ADDRESSES?.PTA_MEETINGS_PATH) {
      await getAllMeetingCategory().then((res) => {
        navigate(menu?.link, {
          state: {
            category: menu?.id === "ptameetings" ? res.data?.allMeetingCategories?.nodes?.[0] : allCategory.filter((val: MeetingCategoryType) => val?.mcCode === menu?.id)?.[0]
          }
        });
      })
    }
    else {
      navigate(menu?.link);
    }
    if (role !== PTA_ROLE) {
      await getNotifications();
    }
    
    // if((role === TEACHER_ROLE || role === STUDENT_ROLE) && schoolType !== VIRTUAL){
    if((role === TEACHER_ROLE || role === STUDENT_ROLE)){
      updateChatActiveStatus({
        variables:{
          chatActive:false
        }
      });
    }
    // if ((role === TEACHER_ROLE && schoolType !== VIRTUAL) || role === PTA_ROLE) {
    if ((role === TEACHER_ROLE) || role === PTA_ROLE) {
      localStorage.setItem('isVerify','false');
    }
    if(role === STUDENT_ROLE){
      getClassRoomUpdates({
        variables :{
          cId : selectedClassRoomId ?? ''
        }
      })
      // if(schoolType !== VIRTUAL){
      getIndicationChat({
        variables: {
          cId: selectedClassRoomId ?? "",
        },
      });
    // }
    }
  }

  const handleClickSchoolProfile = () => {
    if (location.pathname === PATH_ADDRESSES?.TEACHER_PTA_PATH || location.pathname === PATH_ADDRESSES?.PTA_MEETINGS_PATH) {
      setShowPtaSideBar(true);
    }
    if (role !== PTA_ROLE) {
      getNotifications();
    }
    if (location.pathname !== "/school-profile") {
      navigate("/school-profile", {
        state: {
          backNavigation: location.pathname,
          category: selectedCategory
        }
      });
    }
    if(role === STUDENT_ROLE){
      getClassRoomUpdates({
        variables :{
          cId : selectedClassRoomId ?? ''
        }
      })
      // if(schoolType !== VIRTUAL){
      getIndicationChat({
        variables: {
          cId: selectedClassRoomId ?? "",
        },
      });
    // }
    }
  }  

  useEffect(()=>{
    if(selectedClassRoomId){
    if(role === STUDENT_ROLE){
      getClassRoomUpdates({
        variables :{
          cId : selectedClassRoomId ?? ''
        }
      })
      // if(schoolType !== VIRTUAL){
      getIndicationChat({
        variables: {
          cId: selectedClassRoomId ?? "",
        },
      });
    // }
    }
  }
  },[getClassRoomUpdates, getIndicationChat, role, selectedClassRoomId])

    //To check the container is overflow
    const checkOverflow = () => {
      if (schoolNameRef.current) {
        setIsOverflow(schoolNameRef.current.scrollWidth > schoolNameRef.current.clientWidth);
      }
    }

    //To check overflow in resize 
    useEffect(() => {
      window.addEventListener('resize', checkOverflow);
  
      return () => {
        window.removeEventListener('resize', checkOverflow);
      };
    }, []);
  
    useEffect(() => {
      checkOverflow();
    }, [profile])


    const nameRef = useRef<HTMLDivElement | null>(null);
    const [isOverflowdisplay, setIsOverflowDisplay] = useState(false);
    const displayName = StudentName || "Teacher";
  
    const checkOverflowDisplayName = () => {
      if (nameRef.current) {
        setIsOverflowDisplay(nameRef.current.scrollWidth > nameRef.current.clientWidth);
      }
    };
  
    const textRef = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  const checkEllipsis = useCallback(() => {
    if (textRef.current) {
      setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkEllipsis();
    window.addEventListener("resize", checkEllipsis);
    return () => window.removeEventListener("resize", checkEllipsis);
  }, [checkEllipsis, StudentName]);

  const [isEllipsisActiveName, setIsEllipsisActiveName] = useState(false);

  const handleMouseEnter = () => {
    if (nameRef.current) {
      setIsEllipsisActiveName(nameRef.current.scrollWidth > nameRef.current.clientWidth);
    }
  };

  const textRefname = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const checkTextOverflow = () => {
    console.log("entering")
    if (textRefname.current) {
      setShowTooltip(textRefname.current.scrollWidth > textRefname.current.clientWidth);
    }
  };


  return (
    <div className='teacherStudentSidebarMain'>
      <div className='subContainer'>
        <div className={`profileContainer`}>
          <div className={`schoolProfileContainer`} onClick={handleClickSchoolProfile}>
            <div className='schoolProfileTopContainer'>
              {(profileImage) && (
                <img 
                  className='profileImage'
                  alt="ProfileImage"
                  src={profileImage}
                />
              )}
            </div>
            <div className='schoolProfileBottomContainer' style={{gap: role === STUDENT_ROLE ? '8px' : ''}}>
              <Tooltip
                  title={`${profile?.schoolAdmin?.nodes?.[0]?.saName ? profile?.schoolAdmin?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                  disableHoverListener={!isOverflow}
                  placement="top">
                <div className='schoolNameStyle' ref={schoolNameRef}>
                {`${profile?.schoolAdmin?.nodes?.[0]?.saName ? profile?.schoolAdmin?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                </div>
              </Tooltip>
                {
                  role === STUDENT_ROLE
                  ? 
                    <div className='studentTabStyle' onClick={(e) => e.stopPropagation()}>
                       <Tooltip title={isEllipsisActive ? StudentName || "Student" : ""} >
      <div
        ref={textRef}
        style={{
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: "100%",
          display: "block", // Ensure it works inside flex containers
        }}
      >
        {StudentName || "Student"}
      </div>
    </Tooltip>
    <div className="namefield">
      {profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName &&
        profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName !== "" && (
          <Tooltip
            title={showTooltip ? profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName : ""}
            
          >
            <div className="name-span" ref={textRefname} onMouseEnter={checkTextOverflow}>
              {profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName}
            </div>
          </Tooltip>
        )}
    </div>                    </div>
                  : role === TEACHER_ROLE ?
                  <div className='teacherTabStyle' onClick={(e) => e.stopPropagation()}>
                    <Tooltip title={displayName} disableHoverListener={!isOverflowdisplay} placement="top">
                      <div
                        ref={nameRef}
                        style={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          width: "80%",
                        }}
                        onMouseEnter={checkOverflowDisplayName} // Check overflow on hover
                      >
                        {displayName}
                      </div>
                    </Tooltip>
                    <div className="namefield">
      {classRoomName && classRoomName !== "" && (
        <Tooltip title={isEllipsisActiveName ? classRoomName : ""}>
          <div className="name-span" ref={nameRef} onMouseEnter={handleMouseEnter}>
            {classRoomName}
          </div>
        </Tooltip>
      )}
    </div>
                  </div>
                  : role === PTA_ROLE ? 
                    <div className='ptaTabStyle' onClick={(e) => e.stopPropagation()}>PTA</div> 
                  : ""
                }
                
            </div>
          </div>
          <div className='navigationsTop'>
            {
              oneMenuItems?.map((menuitem: menuItemType, index: number) => {
                const notificationKey = menuitem.notificationKey as keyof notificationType;
                const notificationCount = notification ? notification[notificationKey] : 0;
                const isSelected = ((role === PTA_ROLE && location.pathname === PATH_ADDRESSES?.PTA_MEETINGS_PATH) || (role === TEACHER_ROLE && location.pathname === PATH_ADDRESSES?.TEACHER_PTA_PATH)) ? (menuitem?.id === selectedCategory?.mcCode) : (location.pathname === menuitem?.link || location.pathname.includes(menuitem?.link));
                return (<>
                  <button style={{ display: (menuitem?.label === 'Workshop' && role === STUDENT_ROLE) ? 'none' : 'flex' }} key={`${index}-${menuitem?.label}`} className={`sidebarOption ${isSelected ? 'selectedMenu' : ''}`} onClick={() => handleClick(menuitem)}>
                    <span className='MenuLabel'>{menuitem?.label}</span>
                    {!isSelected && notificationCount > 0 && (
                      <span className='notificationBadge'>{notificationCount}</span>
                    )}
                    {isSelected && <img
                      src={rightSideArrow}
                      alt='arrowIcon'
                      className={`arrowIconStyle ${((location.pathname === menuitem?.link) || (location.pathname.includes(menuitem?.link))) ? 'visibleStyle' : 'nonVisibleStyle'}`}
                    />}
                    {(role === STUDENT_ROLE && menuitem?.label) === 'Classroom' && <img src={redDotImage} className='redDotStyle' alt='redDotImage' style={{visibility : isIndication || isIndicationChat ? 'visible':'hidden'}}/>}

                  </button>
                  </>
                )
              })
            }
          </div>
        </div>
          <div className={`navigationsBottom ${role === PTA_ROLE && 'navigationsBottomPta'}`}>
            <div className='setTwoMenuContainer'>
            {
              setTwoMenuItems?.map((item, index) => {
                const isSelected = (location.pathname === item?.link || location.pathname.includes(item?.link))
                return (
                  <div className='setTwoMenuItemStyle' key={`${index}-${item.label}`} onClick={item.onClick ? item.onClick : () => handleClick(item)}>
                      <img
                        src={item.icon}
                        alt='icon'
                        className='iconStyle'
                      />
                      <span className={`labelStyle ${isSelected && 'labelStyleActive'}`}>{item?.label}</span>
                  </div>
                )
              })
            }
            </div>
          </div>
      </div>
      <ConfirmationPopup
        open = {openConfirmationPopup}
        message = {logoutMessage}
        gifData = {logoutGif}
        yesButtonFunctionality = {onClickYesButtonClick}
        noButtonFunctionality = {onClickNoButtonClick}
        messageWidth = {'345px'}
        popupContainerHeight = {(getIsJoinedLocalValue() === 'joined') ? '230px' : '202px'}
      />
    </div>
  )
}

export default TeacherStudentSidebar